import Flex from '@Resources/styles/flex.scss';
import { Skeleton } from '@mui/material';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Styles from './Folders.scss';

const FolderOptionSkeleton = (props) => {
    const textWidth = Math.floor(Math.random() * (200 - 150 + 1) + 150);

    return (
        <div className={Styles.folderOptionContainer}>
            <div className={cx(Flex.flex, Flex.grow)}>
                <div className={Styles.foDragContainer}></div>
                <div className={Styles.foMainContainer}>
                    <Skeleton
                        animation="wave"
                        variant="text"
                        width={textWidth}
                    />
                </div>
            </div>

            <div className={Flex.flex}>
                <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width={25}
                    style={{ marginRight: '10px' }}
                    height={20}
                />
            </div>
        </div>
    );
};

export default FolderOptionSkeleton;
